import { createContext, useState } from "react";
import { CONST_GENDER_MALE } from "../helpers";

export const ContextProfileUser = createContext(null);

export const defaultProfileUser = {
  first_name: "",
  email: "",
  password: "",
  gender: CONST_GENDER_MALE.toString(),
  birthday: "",
  day: "",
  month: "",
  year: "",
};

export const ProfileUserProvider = (props) => {
  const [data, setData] = useState(defaultProfileUser);
  const { children } = props;

  return (
    <ContextProfileUser.Provider value={{ data, setData }}>
      {children}
    </ContextProfileUser.Provider>
  );
};
